module.exports = __webpack_public_path__ + "static/zero-concurrence-dd0970c1f12210bfb83ad71466930172.jpg";